import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-cream via-rose-100/30 to-cream" data-id="element-49">
      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-12 md:pt-16" data-id="element-50">
        {/* Pain Point Section - Above title */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto mb-10" data-id="element-51">
          <div className="relative rounded-3xl overflow-hidden shadow-warm-xl mb-6" data-id="element-52">
            <img src="https://cdn.magicpatterns.com/uploads/7ZraHBbJQXEFtbtE9GpLcH/landing_RR_dolor.png" alt="Mamá agotada frente a la heladera abierta sin saber qué cocinar" className="w-full object-cover aspect-[16/7]" data-id="element-53" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-54" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-55">
              <p className="font-display text-4xl md:text-6xl text-white text-center px-6 drop-shadow-lg" style={{
              textShadow: '0 3px 12px rgba(0,0,0,0.6)'
            }} data-id="element-56">
                "¿Qué cocino hoy?"
              </p>
            </div>
          </div>
          <div className="text-center max-w-2xl mx-auto" data-id="element-57">
            <p className="font-heading text-2xl md:text-3xl font-bold text-brown-dark leading-snug mb-2" data-id="element-58">
              Son las 18:00… abrís la heladera, estás agotada y vuelve la misma
              pregunta.
            </p>
            <p className="font-body text-base md:text-lg text-brown-light leading-relaxed" data-id="element-59">
              Sin ideas, sin tiempo y con chicos con hambre, terminás
              improvisando (y estresándote) otra vez.
            </p>
          </div>
        </motion.div>

        {/* Main Hero Content */}
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 pb-12 md:pb-16" data-id="element-60">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-61">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-62">
              <span className="inline-block px-4 py-2 mb-6 text-sm font-semibold text-orange bg-orange/10 rounded-full border border-orange/20" data-id="element-63">
                📗 Ebook Completo + Bono Exclusivo
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="font-display text-7xl md:text-9xl text-brown-dark mb-4 leading-none" style={{
            textShadow: '3px 3px 6px rgba(45, 27, 14, 0.15)'
          }} data-id="element-64">
              Recetas
              <br data-id="element-65" />
              <span className="text-orange" style={{
              textShadow: '3px 3px 6px rgba(212, 98, 43, 0.25)'
            }} data-id="element-66">
                Rescate
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="font-body text-lg md:text-xl text-brown-light max-w-2xl mb-8 leading-relaxed" data-id="element-67">
              30 recetas listas para cuando no sabés qué cocinar. Rápidas, ricas
              y con lo que tenés en casa.
            </motion.p>

            {/* Solution Image with overlaid text */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.7,
            delay: 0.5
          }} className="relative mb-8 max-w-lg mx-auto md:mx-0" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/iZpq5VH9Dc1J3FeXpM1CRw/landing_RR_solucion.png" alt="Mamá sonriendo mientras usa el ebook Recetas Rescate en su tablet, con una tarta y viandas preparadas" className="w-full rounded-3xl shadow-warm-xl object-cover aspect-[4/3]" data-id="element-69" />
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-70" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6" data-id="element-71">
                <p className="font-heading text-lg md:text-xl font-bold text-white leading-snug" style={{
                textShadow: '0 2px 8px rgba(0,0,0,0.5)'
              }} data-id="element-72">
                  Soluciones de 15 Minutos para Mamás Ocupadas
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} data-id="element-73">
              <motion.a href="https://www.mamaexpres.com/cart/53191481131281:1" onClick={() => trackAddToCart()} whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center gap-3 px-8 py-4 bg-orange text-white font-semibold text-lg rounded-full shadow-warm-lg hover:bg-orange-dark hover:shadow-warm-xl transition-all duration-300" data-id="element-74">
                ¡Quiero mis Recetas Rescate!
                <ArrowRightIcon className="w-5 h-5" data-id="element-75" />
              </motion.a>
            </motion.div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} className="mt-4 text-sm text-brown-muted" data-id="element-76">
              ⚡ Descarga inmediata • Acceso de por vida
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
}